import { createFileRoute } from "@tanstack/solid-router";
import { seo } from "~/utils/seo";

export const Route = createFileRoute("/_main/contact")({
  head: () => ({
    meta: seo({
      title: "Contact | ActShark",
      description:
        "Contact ActShark for support, billing, or partnership questions.",
      path: "/contact",
      robots: "index, follow",
    }),
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <main class="flex min-h-screen flex-col pt-20">
      <section class="relative px-6 py-12 md:py-16 sm:px-8">
        <div class="mx-auto w-full max-w-5xl">
          <div class="mb-12 text-center">
            <h1 class="text-4xl font-bold tracking-tight sm:text-5xl">
              Get in Touch
            </h1>
            <p class="mx-auto mt-4 max-w-2xl text-base text-muted-foreground">
              Have a question or want to work together? We would love to hear
              from you.
            </p>
          </div>

          <div class="mx-auto grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-3">
            <div class="rounded-xl border bg-card p-5 text-center">
              <h2 class="mb-2 text-base font-semibold">Email</h2>
              <p class="text-sm text-muted-foreground">
                Send us a note at hello@actshark.com
              </p>
            </div>
            <div class="rounded-xl border bg-card p-5 text-center">
              <h2 class="mb-2 text-base font-semibold">Response Time</h2>
              <p class="text-sm text-muted-foreground">
                Typically within 1-2 business days
              </p>
            </div>
            <div class="rounded-xl border bg-card p-5 text-center">
              <h2 class="mb-2 text-base font-semibold">Privacy</h2>
              <p class="text-sm text-muted-foreground">
                Your information is secure and protected
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
